var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CircularProgress, InputLabel, Select, Snackbar, Button } from "@material-ui/core";
import PyEditor from "./PyEditor";
import AnimatedOutputBox from "./AnimatedOutputBox";
import { v4 as uuid } from "uuid";
import { EditorState } from "../types";
import FeedbackForm from "./FeedbackForm";
import styled from "styled-components";
import { OverlayCenterWrapper } from "./Overlay";
import { useWorker } from "../hooks/useWorker";
import { parseTestCases } from "../services/test_parsing";
import EditorOutput from "./EditorOutput";
import TestOutput from "./TestOutput";
import SubmissionOutput from "./SubmissionOutput";
import Problems from "./Problems";
import { faExclamationCircle, faPlay, faStop } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-regular-svg-icons";
import SubmittingOutput from "./SubmittingOutput";
import useStyles from "../hooks/useStyles";
import AlertDialog from "./AlertDialog";
import useCachedFileEntries from "../hooks/useCachedFileEntries";
import { emptyFile, exampleFiles } from "../constants";
import WithBrowserIncompatibilityOverlay from "./WithBrowserIncompatibilityOverlay";
var StyledButton = styled(function (props) {
  return React.createElement(Button, __assign({
    variant: "contained"
  }, props));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0.5em;\n"], ["\n  margin: 0.5em;\n"])));
var initialFiles = {
  value: [emptyFile],
  timestamp: -1
};
var ProgrammingExercise = function ProgrammingExercise(_a) {
  var _b;
  var submitFeedback = _a.submitFeedback,
    submitProgrammingExercise = _a.submitProgrammingExercise,
    submitToPaste = _a.submitToPaste,
    cacheKey = _a.cacheKey,
    debug = _a.debug,
    exercise = _a.exercise,
    submitDisabled = _a.submitDisabled,
    solutionUrl = _a.solutionUrl,
    editorHeight = _a.editorHeight,
    outputHeight = _a.outputHeight;
  var t = useTranslation()[0];
  var _c = useState([]),
    output = _c[0],
    setOutput = _c[1];
  var _d = useState(),
    testResults = _d[0],
    setTestResults = _d[1];
  var _e = useState(true),
    workerAvailable = _e[0],
    setWorkerAvailable = _e[1];
  var _f = useCachedFileEntries(cacheKey, initialFiles),
    files = _f[0],
    setFiles = _f[1],
    setFilesIfNewer = _f[2];
  var _g = useState(0),
    activeFile = _g[0],
    setActiveFile = _g[1];
  var _h = useState(false),
    openNotification = _h[0],
    setOpenNotification = _h[1];
  var _j = useState(),
    executionTimeoutTimer = _j[0],
    setExecutionTimeoutTimer = _j[1];
  var worker = useWorker({
    debug: debug
  })[0];
  var outputBoxRef = React.createRef();
  var _k = useState(EditorState.Initializing),
    editorState = _k[0],
    setEditorState = _k[1];
  var classes = useStyles();
  function handleRun(code) {
    if (workerAvailable) {
      setOutput([]);
      setTestResults(undefined);
      setWorkerAvailable(false);
      setEditorState(EditorState.WorkerInitializing);
      worker.postMessage({
        type: "run",
        msg: {
          code: code !== null && code !== void 0 ? code : files[activeFile].content,
          debug: debug
        }
      });
    } else {
      console.log("Worker is busy");
    }
  }
  function handleTests(code) {
    if (workerAvailable) {
      var testCode = exercise.getTestProgram(code !== null && code !== void 0 ? code : files[activeFile].content);
      setOutput([]);
      setTestResults(undefined);
      setWorkerAvailable(false);
      setEditorState(EditorState.WorkerInitializing);
      worker.postMessage({
        type: "run_tests",
        msg: {
          code: testCode,
          debug: debug
        }
      });
    } else {
      console.log("Worker is busy");
    }
  }
  var handleSubmit = function handleSubmit() {
    setEditorState(EditorState.Submitting);
    setTestResults(undefined);
  };
  var handleReset = function handleReset() {
    setFiles(exercise.projectFiles.map(function (x) {
      return __assign(__assign({}, x), {
        content: x.originalContent
      });
    }));
    setActiveFile(0);
    setOutput([]);
    setTestResults(undefined);
  };
  worker.setMessageListener(function (e) {
    var _a = e.data,
      type = _a.type,
      msg = _a.msg;
    switch (type) {
      case "print":
        setOutput(output.concat({
          id: uuid(),
          type: "output",
          text: msg
        }));
        break;
      case "input_required":
        setEditorState(EditorState.WaitingInput);
        break;
      case "error":
        console.error(msg);
        setOutput(output.concat({
          id: uuid(),
          type: "error",
          text: msg,
          traceback: e.data.traceback
        }));
        setWorkerAvailable(true);
        worker.recycle();
        break;
      case "ready":
        setWorkerAvailable(true);
        break;
      case "print_batch":
        if (editorState === EditorState.ExecutingCode) {
          var prints_1 = msg.map(function (text) {
            return {
              id: uuid(),
              type: "output",
              text: text
            };
          });
          setOutput(function (prevState) {
            return prevState.concat(prints_1);
          });
        }
        break;
      case "print_done":
        setEditorState(function (previous) {
          switch (previous) {
            case EditorState.Testing:
              if ((testResults === null || testResults === void 0 ? void 0 : testResults.allTestsPassed) && !submitDisabled) {
                handleSubmit();
              }
              return EditorState.ShowTestResults;
            default:
              return EditorState.Idle;
          }
        });
        worker.recycle();
        break;
      case "test_results":
        {
          var testCases = parseTestCases(msg);
          setOutput([]);
          setTestResults({
            allTestsPassed: testCases.every(function (x) {
              return x.passed;
            }),
            points: [],
            testCases: testCases
          });
          break;
        }
      case "start_run":
        setEditorState(EditorState.ExecutingCode);
        break;
      case "start_test":
        setEditorState(EditorState.Testing);
        break;
    }
  });
  var sendInput = function sendInput(input) {
    if (editorState === EditorState.WaitingInput) {
      setEditorState(EditorState.ExecutingCode);
      setOutput(output.concat({
        id: uuid(),
        type: "input",
        text: input + "\n"
      }));
      worker.postMessage({
        type: "input",
        msg: input
      });
    }
  };
  useEffect(function () {
    var _a, _b;
    setFilesIfNewer({
      value: exercise.projectFiles,
      timestamp: (_b = (_a = exercise.submissionDetails) === null || _a === void 0 ? void 0 : _a.createdAtMillis) !== null && _b !== void 0 ? _b : -1
    });
  }, [exercise.projectFiles, (_b = exercise.submissionDetails) === null || _b === void 0 ? void 0 : _b.createdAtMillis, setFilesIfNewer]);
  useEffect(function () {
    debug && console.log(EditorState[editorState]);
    switch (editorState) {
      case EditorState.Submitting:
        submitProgrammingExercise(files).then(function (data) {
          closeOutput();
          setTestResults(data);
          setOutput([]);
          setEditorState(data.allTestsPassed ? EditorState.ShowPassedFeedbackForm : EditorState.ShowSubmissionResults);
        });
        break;
      case EditorState.ExecutingCode:
      case EditorState.Testing:
        {
          var msg_1 = t("infiniteLoopMessage");
          var timeout = setTimeout(function () {
            setOutput([{
              id: uuid(),
              type: "output",
              text: msg_1
            }]);
            stopWorker();
          }, 10000);
          setExecutionTimeoutTimer(timeout);
          break;
        }
      case EditorState.Idle:
      case EditorState.RunAborted:
      case EditorState.ShowTestResults:
      case EditorState.WaitingInput:
        if (executionTimeoutTimer) {
          clearTimeout(executionTimeoutTimer);
        }
        break;
    }
  }, [editorState]);
  var stopWorker = function stopWorker() {
    if (!workerAvailable) {
      worker.terminate();
    }
    worker.postMessage({
      type: "stop"
    });
    setEditorState(EditorState.RunAborted);
    setWorkerAvailable(true);
  };
  var closeOutput = function closeOutput() {
    var _a;
    stopWorker();
    (_a = outputBoxRef.current) === null || _a === void 0 ? void 0 : _a.close();
    setEditorState(EditorState.Idle);
    setOutput([]);
  };
  var handleCloseNotification = function handleCloseNotification(event, reason) {
    if (reason === "clickaway") {
      return;
    }
    setOpenNotification(false);
  };
  var handleFileChange = function handleFileChange(e) {
    var _a;
    setActiveFile((_a = files.findIndex(function (x) {
      return x.shortName === e.target.value;
    })) !== null && _a !== void 0 ? _a : 0);
  };
  var mapStateToOutput = function mapStateToOutput() {
    switch (editorState) {
      case EditorState.ShowTestResults:
        return React.createElement(TestOutput, {
          getPasteLink: function getPasteLink() {
            return submitToPaste(files);
          },
          onClose: closeOutput,
          outputHeight: outputHeight,
          onSubmit: function onSubmit() {
            return handleSubmit();
          },
          submitDisabled: submitDisabled,
          testResults: testResults !== null && testResults !== void 0 ? testResults : {
            points: [],
            testCases: []
          }
        });
      case EditorState.ShowPassedFeedbackForm:
      case EditorState.ShowSubmissionResults:
        return React.createElement(SubmissionOutput, {
          onClose: closeOutput,
          onSubmit: function onSubmit() {
            return handleSubmit();
          },
          testResults: testResults !== null && testResults !== void 0 ? testResults : {
            points: [],
            testCases: []
          },
          getPasteLink: function getPasteLink() {
            return submitToPaste(files);
          },
          pasteDisabled: submitDisabled,
          outputHeight: outputHeight
        });
      case EditorState.Submitting:
        return React.createElement(SubmittingOutput, {
          onClose: closeOutput,
          getPasteLink: function getPasteLink() {
            return submitToPaste(files);
          },
          pasteDisabled: true
        });
      case EditorState.ShowProblems:
        return React.createElement(Problems, {
          onClose: closeOutput,
          problems: exercise.templateIssues,
          outputHeight: outputHeight
        });
      default:
        return React.createElement(EditorOutput, {
          editorState: editorState,
          getPasteLink: function getPasteLink() {
            return submitToPaste(files);
          },
          onClose: closeOutput,
          outputContent: output,
          outputHeight: outputHeight,
          pasteDisabled: submitDisabled,
          sendInput: sendInput
        });
    }
  };
  var handleEditorValueChange = function handleEditorValueChange(newContent) {
    if (!exercise.ready) return;
    setFiles(function (prev) {
      return prev.map(function (x, i) {
        return i !== activeFile ? x : __assign(__assign({}, x), {
          content: newContent
        });
      });
    });
  };
  var pyEditorButtonsDisabled = (editorState & (EditorState.WorkerActive | EditorState.Submitting)) === 0;
  return React.createElement(WithBrowserIncompatibilityOverlay, null, editorState === EditorState.ShowPassedFeedbackForm && React.createElement(FeedbackForm, {
    awardedPoints: testResults === null || testResults === void 0 ? void 0 : testResults.points,
    onSubmitFeedback: function onSubmitFeedback(feedback) {
      setEditorState(EditorState.ShowSubmissionResults);
      if (testResults) {
        submitFeedback(testResults, feedback);
        feedback.length > 0 && setOpenNotification(true);
      }
    },
    onClose: function onClose() {
      return setEditorState(EditorState.ShowSubmissionResults);
    },
    solutionUrl: testResults === null || testResults === void 0 ? void 0 : testResults.solutionUrl,
    feedbackQuestions: testResults === null || testResults === void 0 ? void 0 : testResults.feedbackQuestions
  }), files.length > 1 && React.createElement(React.Fragment, null, React.createElement(InputLabel, {
    id: "label"
  }, t("selectFile")), React.createElement(Select, {
    labelId: "label",
    native: true,
    value: files[activeFile].shortName,
    onChange: handleFileChange,
    "data-cy": "select-file"
  }, React.createElement(React.Fragment, null, files.map(function (_a) {
    var shortName = _a.shortName;
    return React.createElement("option", {
      key: shortName,
      value: shortName
    }, shortName);
  })))), !exercise.ready && React.createElement(OverlayCenterWrapper, null, React.createElement(CircularProgress, {
    thickness: 5,
    color: "inherit"
  })), React.createElement(PyEditor, {
    editorValue: files[activeFile].content,
    setEditorValue: handleEditorValueChange,
    editorHeight: editorHeight,
    setIsEditorReady: function setIsEditorReady(isReady) {
      return setEditorState(isReady ? EditorState.Idle : EditorState.Initializing);
    }
  }), React.createElement("div", {
    style: {
      padding: "0.6em 0em"
    }
  }, (editorState & EditorState.WorkerActive) === 0 ? React.createElement(StyledButton, {
    onClick: function onClick() {
      return handleRun();
    },
    className: classes.runButton,
    disabled: !(workerAvailable && pyEditorButtonsDisabled),
    "data-cy": "run-btn"
  }, React.createElement(FontAwesomeIcon, {
    icon: faPlay
  }), React.createElement("span", {
    className: classes.whiteText
  }, t("runButtonText"))) : React.createElement(StyledButton, {
    className: classes.stopButton,
    onClick: function onClick() {
      return stopWorker();
    },
    "data-cy": "stop-btn"
  }, React.createElement(FontAwesomeIcon, {
    icon: faStop
  }), React.createElement("span", {
    className: classes.whiteText
  }, t("stopButtonText"))), React.createElement(StyledButton, {
    onClick: function onClick() {
      return handleTests();
    },
    disabled: !pyEditorButtonsDisabled,
    className: classes.testButton,
    "data-cy": "test-btn"
  }, React.createElement(FontAwesomeIcon, {
    icon: faEye
  }), React.createElement("span", {
    style: {
      paddingLeft: "5px"
    }
  }, t("testButtonText"))), React.createElement(AlertDialog, {
    resetExercise: handleReset
  }), solutionUrl && React.createElement(StyledButton, {
    className: classes.normalButton,
    onClick: function onClick() {
      return window.open(solutionUrl, "_blank");
    }
  }, t("modelSolution")), exercise.templateIssues.length > 0 && React.createElement(StyledButton, {
    onClick: function onClick() {
      var _a;
      setEditorState(EditorState.ShowProblems);
      (_a = outputBoxRef.current) === null || _a === void 0 ? void 0 : _a.open();
    },
    disabled: (editorState & EditorState.WorkerActive) > 0,
    className: classes.problemsButton,
    "data-cy": "problems-btn"
  }, React.createElement(FontAwesomeIcon, {
    icon: faExclamationCircle
  }), React.createElement("span", {
    className: classes.whiteText
  }, t("problemsTitle") + " (" + exercise.templateIssues.length + ")"))), React.createElement(AnimatedOutputBox, {
    isRunning: (editorState & EditorState.WorkerActive) > 0,
    outputHeight: outputHeight,
    ref: outputBoxRef
  }, mapStateToOutput()), debug && React.createElement("div", null, React.createElement("div", null, "EditorState: ", EditorState[editorState]), React.createElement("div", null, "Cache key: ", cacheKey || "undefined"), React.createElement("div", null, "Active file: ", files[activeFile].fullName)), React.createElement(Snackbar, {
    open: openNotification,
    autoHideDuration: 5000,
    onClose: handleCloseNotification,
    message: t("thankYouForFeedback"),
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    key: "bottom-center"
  }));
};
ProgrammingExercise.defaultProps = {
  submitProgrammingExercise: function submitProgrammingExercise() {
    return Promise.resolve({
      points: [],
      testCases: []
    });
  },
  submitToPaste: function submitToPaste() {
    return Promise.resolve("default paste called");
  },
  exercise: {
    details: undefined,
    projectFiles: exampleFiles,
    ready: true,
    reset: function reset() {
      return console.log("Called for exercise reset.");
    },
    templateIssues: [],
    updateDetails: function updateDetails() {
      return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2, console.log("Called for exercise details update.")];
        });
      });
    },
    getTestProgram: function getTestProgram() {
      return 'print("Default test called.")';
    }
  }
};
export { ProgrammingExercise };
var templateObject_1;